import Rail from '../../classes/rail';
import Recording from '../../types/enums/recording';
import recordingsObservable from '../../api/recording/recordingsObservable';
import updateRecordings from './updateRecordings';
import { IRecordIdentifier } from '../../types/interfaces/record';
import { Observer } from 'rxjs';

function initRecordings(finished = true, pending = true, identifiers = true) {
  const recordingsObserver: Observer<{
    data: IRecordIdentifier[] | Rail[];
    type: Recording;
  }> = {
    next: (val: { data: IRecordIdentifier[] | Rail[]; type: Recording }) => {
      const { data, type } = val;
      updateRecordings(data, type);
    },
    error: () => {
      console.error('Error recovering recordings');
    },
    complete: () => {
      return null;
    },
  };
  recordingsObservable(finished, pending, identifiers).subscribe(
    recordingsObserver as Partial<Observer<unknown>>
  );
  return recordingsObserver;
}

export default initRecordings;
